import React from 'react';

import { Button } from 'carbon-components-react';


export const WarningModal = (props) => (
    <div className="bx--modal bx--modal-tall is-visible" >
        <div className="bx--modal-container modal-overflow-visible">
            <div className="bx--modal-header"><h3 className="bx--modal-header__heading">Warning!</h3> </div>
            <div className="bx--row mt-20">
                <div className="bx--col-lg-12 bx--col-md-12">
                    {props.message}
                </div>
            </div>
            <div className="searchFormFooter mt-20">
                <Button className="button--max-width" kind="secondary" onClick={props.onCancel} >
                    Cancel
                </Button>
                <Button className="button--max-width" kind='primary' onClick={props.onConfirm} >
                    Confirm
                </Button>
            </div>
        </div>
    </div>
)

